import { forwardRef, type HTMLAttributes, type LegacyRef } from 'react';
import styled from 'styled-components';
import { type SvgSpriteType, spriteIndexObj, spriteSymbolUrl } from 'autogen/spriteData';

interface ISpriteDataValue {
    id: string;
    classList?: string;
}

function getSpriteData(iconType: SvgSpriteType): ISpriteDataValue {
    return spriteIndexObj[iconType];
}

export interface ISvgSprite extends HTMLAttributes<HTMLOrSVGElement> {
    sprite: SvgSpriteType;
    fill?: string;
}

const SvgElement = styled.svg``;

export default function icon(iconName: SvgSpriteType, modifiers = ''): string {
    const { id, classList = '' } = getSpriteData(iconName);
    const path = `${spriteSymbolUrl}#${id}`;

    return `
        <svg class="icon ${classList} ${modifiers}">
            <use href="${path}"></use>
        </svg>
    `;
}

export const SvgSprite = forwardRef((props: ISvgSprite, ref: LegacyRef<SVGSVGElement>): JSX.Element => {
    const { sprite, fill, className = '', ...rest } = props;

    if (!sprite) throw new Error(`Invalid sprite property of ${sprite || 'undefined'} was provided to SVG Sprite`);

    const { id, classList = '' } = getSpriteData(sprite) || {};
    const path = `${spriteSymbolUrl}#${id}`;

    return (
        <SvgElement className={`icon ${classList} ${className}`} {...rest} ref={ref}>
            <use fill={fill} href={path} />
        </SvgElement>
    );
});
